import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./PortalPage.css";
import logoNegativo from "../../assets/ttflow-logo-negativo@3x.png";
import iconeCyan from "../../assets/ttflow-icone-cyan@3x.png";
import iconeAzul from "../../assets/ttflow-icone@2x.png";

const MENSAGERIA_URL = "/mensageria/";
// Writer é publicado no domínio em /nfw/ (não /writer/ — esse caminho cai no próprio Inbound).
const WRITER_URL = "/nfw/login";
const APURACAO_URL = "/apuracao/login";

const PortalPage = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const updateHeader = () => setScrolled(window.scrollY > 40);
    updateHeader();
    window.addEventListener("scroll", updateHeader);
    return () => window.removeEventListener("scroll", updateHeader);
  }, []);

  return (
    <div className="portal-page">
      <header className={scrolled ? "scrolled" : ""}>
        <Link className="back-link" to="/"><span className="arrow">&larr;</span> Voltar</Link>
      </header>

      <main>
        <div>
          <img className="portal-mark" src={logoNegativo} alt="TTflow" />

          <span className="kicker">// Portal</span>
          <h1>Selecione o sistema</h1>
          <p className="subtitle">Escolha qual plataforma você deseja acessar</p>

          <div className="cards">
            <a className="card mensageria" href={MENSAGERIA_URL}>
              <img className="icon" src={iconeCyan} alt="" />
              <h2>Mensageria</h2>
              <p>Gestão de NF-e / NFS-e e mensageria fiscal</p>
            </a>

            <Link className="card inbound" to="/login">
              <img className="icon" src={iconeAzul} alt="" />
              <h2>Inbound</h2>
              <p>Automação do processo de recebimento fiscal</p>
            </Link>

            <a className="card writer" href={WRITER_URL}>
              <img className="icon" src={iconeCyan} alt="" />
              <h2>Writer</h2>
              <p>Emissão de notas fiscais Writer (NFW)</p>
            </a>

            <a className="card apuracao" href={APURACAO_URL}>
              <img className="icon" src={iconeAzul} alt="" />
              <h2>Apuração Assistida</h2>
              <p>Apuração assistida - IBS/CBS</p>
            </a>
          </div>
        </div>
      </main>

      <footer>
        <div className="footer-social">
          <a href="https://www.instagram.com/escotta_consulting/" aria-label="Instagram" target="_blank" rel="noopener noreferrer">
            <svg viewBox="0 0 24 24"><path d="M12 2c2.72 0 3.06.01 4.12.06 1.06.05 1.79.22 2.43.47.66.26 1.22.6 1.77 1.15.55.55.9 1.11 1.15 1.77.25.64.42 1.37.47 2.43.05 1.06.06 1.4.06 4.12s-.01 3.06-.06 4.12c-.05 1.06-.22 1.79-.47 2.43a4.9 4.9 0 0 1-1.15 1.77 4.9 4.9 0 0 1-1.77 1.15c-.64.25-1.37.42-2.43.47-1.06.05-1.4.06-4.12.06s-3.06-.01-4.12-.06c-1.06-.05-1.79-.22-2.43-.47a4.9 4.9 0 0 1-1.77-1.15 4.9 4.9 0 0 1-1.15-1.77c-.25-.64-.42-1.37-.47-2.43C2.01 15.06 2 14.72 2 12s.01-3.06.06-4.12c.05-1.06.22-1.79.47-2.43.26-.66.6-1.22 1.15-1.77A4.9 4.9 0 0 1 5.45 2.53c.64-.25 1.37-.42 2.43-.47C8.94 2.01 9.28 2 12 2Zm0 1.8c-2.67 0-2.99.01-4.04.06-.87.04-1.34.18-1.65.3-.42.16-.72.36-1.03.67-.31.31-.51.61-.67 1.03-.12.31-.26.78-.3 1.65C4.26 8.51 4.25 8.83 4.25 12s.01 3.49.06 4.54c.04.87.18 1.34.3 1.65.16.42.36.72.67 1.03.31.31.61.51 1.03.67.31.12.78.26 1.65.3 1.05.05 1.37.06 4.04.06s2.99-.01 4.04-.06c.87-.04 1.34-.18 1.65-.3.42-.16.72-.36 1.03-.67.31-.31.51-.61.67-1.03.12-.31.26-.78.3-1.65.05-1.05.06-1.37.06-4.54s-.01-3.49-.06-4.54c-.04-.87-.18-1.34-.3-1.65a2.77 2.77 0 0 0-.67-1.03 2.77 2.77 0 0 0-1.03-.67c-.31-.12-.78-.26-1.65-.3C14.99 3.81 14.67 3.8 12 3.8Zm0 3.05a5.15 5.15 0 1 1 0 10.3 5.15 5.15 0 0 1 0-10.3Zm0 1.8a3.35 3.35 0 1 0 0 6.7 3.35 3.35 0 0 0 0-6.7Zm5.34-1.98a1.2 1.2 0 1 1-2.4 0 1.2 1.2 0 0 1 2.4 0Z"/></svg>
          </a>
          <a href="https://www.facebook.com/escotta" aria-label="Facebook" target="_blank" rel="noopener noreferrer">
            <svg viewBox="0 0 24 24"><path d="M13.5 21v-7.6h2.55l.38-2.96h-2.93V8.56c0-.86.24-1.44 1.47-1.44h1.57V4.47C16.24 4.4 15.32 4.3 14.24 4.3c-2.24 0-3.78 1.37-3.78 3.87v2.16H7.9v2.96h2.56V21h3.04Z"/></svg>
          </a>
          <a href="http://linkedin.com/company/escotta/posts/?feedView=all" aria-label="LinkedIn" target="_blank" rel="noopener noreferrer">
            <svg viewBox="0 0 24 24"><path d="M6.94 8.5H3.56V20.4h3.38V8.5ZM5.25 3.1a1.96 1.96 0 1 0 0 3.92 1.96 1.96 0 0 0 0-3.92ZM20.44 20.4v-6.53c0-3.5-1.87-5.13-4.36-5.13-2.01 0-2.91 1.1-3.41 1.88V8.5H9.29c.04.96 0 11.9 0 11.9h3.38v-6.65c0-.36.03-.71.13-.97.29-.71.94-1.45 2.04-1.45 1.44 0 2.02 1.1 2.02 2.7v6.37h3.58Z"/></svg>
          </a>
          <a href="https://www.youtube.com/c/Escotta" aria-label="YouTube" target="_blank" rel="noopener noreferrer">
            <svg viewBox="0 0 24 24"><path d="M22 12s0-3.15-.4-4.66a2.79 2.79 0 0 0-1.96-1.98C18.02 5 12 5 12 5s-6.02 0-7.64.36a2.79 2.79 0 0 0-1.96 1.98C2 8.85 2 12 2 12s0 3.15.4 4.66c.22.82.98 1.5 1.96 1.72C6.02 19 12 19 12 19s6.02 0 7.64-.62a2.79 2.79 0 0 0 1.96-1.72C22 15.15 22 12 22 12ZM10 15.5v-7l6 3.5-6 3.5Z"/></svg>
          </a>
        </div>
        <span>&copy; 2026 Escotta &middot; TTflow</span>
      </footer>
    </div>
  );
};

export default PortalPage;
